/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type TensionInfo_organization$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type TensionInfo_tension$ref: FragmentReference;
declare export opaque type TensionInfo_tension$fragmentType: TensionInfo_tension$ref;
export type TensionInfo_tension = {|
  +createdAt: any,
  +body: string,
  +agendaLabel: ?string,
  +impactedRole: ?{|
    +localizedName: string
  |},
  +person: ?{|
    +id: string,
    +name: string,
    +isActive: boolean,
  |},
  +organization: {|
    +$fragmentRefs: TensionInfo_organization$ref
  |},
  +$refType: TensionInfo_tension$ref,
|};
export type TensionInfo_tension$data = TensionInfo_tension;
export type TensionInfo_tension$key = {
  +$data?: TensionInfo_tension$data,
  +$fragmentRefs: TensionInfo_tension$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TensionInfo_tension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "body",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "agendaLabel",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Role",
      "kind": "LinkedField",
      "name": "impactedRole",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "localizedName",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Person",
      "kind": "LinkedField",
      "name": "person",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isActive",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Organization",
      "kind": "LinkedField",
      "name": "organization",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TensionInfo_organization"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Tension",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = '799ded600df32d574e5170323e3b4b42';

module.exports = node;
